/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutenglishoptional3Inputs */

const en_organizeraboutenglishoptional3 = /** @type {(inputs: Organizeraboutenglishoptional3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In English (optional)`)
};

const de_organizeraboutenglishoptional3 = /** @type {(inputs: Organizeraboutenglishoptional3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Englisch (freiwillig)`)
};

/**
* | output |
* | --- |
* | "In English (optional)" |
*
* @param {Organizeraboutenglishoptional3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutenglishoptional3 = /** @type {((inputs?: Organizeraboutenglishoptional3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutenglishoptional3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutenglishoptional3(inputs)
	return de_organizeraboutenglishoptional3(inputs)
});
export { organizeraboutenglishoptional3 as "organizerAboutEnglishOptional" }